<template>
    <div class="SiteHeader">
        <SiteSidebar :class="{opened: !menuClosed}" :user="user"/>
        <div class="sidebarOverlay" :class="{opened: !menuClosed}" @click="toggleMenu"></div>

        <Container>
            <div class="main">
                <router-link to="/">
                    <Logo/>
                </router-link>

                <div class="nav">
                    <div class="navMenuItem">
                        <Button to="/about" class="link primary">About</Button>
                        <Button to="/contact" class="link primary">Contact</Button>
                        <Dropdown :triggerOnHover="true">
                            <template #trigger>
                                <Button class="link primary">Resources</Button>
                            </template>
                            <template #menu>
                                <router-link to="/support">Training</router-link>
                                <router-link to="/support">FAQ</router-link>
                                <router-link to="/resources/haulingcalc">Hauling Calculator</router-link>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>

            <div class="aside">
                <Dropdown v-if="user">
                    <template #trigger>
                        <CompanyLogo nameDisplay="user"/>
                    </template>
                    <template #menu>
                        <router-link v-if="user.role !== 'driver'" to="/company/dashboard">Dashboard</router-link>
                        <router-link v-if="user.role !== 'driver'" to="/company/settings">Settings</router-link>
                        <button class="danger" @click="handleLogout">Log out</button>
                    </template>
                </Dropdown>
                <div v-else>
                    <Button to="/login" class="outline primary">Log In</Button>
                    <Button to="/signup" class="primary">Sign Up</Button>
                </div>
            </div>

            <div class="menu" @click="toggleMenu">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </Container>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Logo from '@/components/Logo';
import Dropdown from '@/components/Dropdown';
import CompanyLogo from '@/components/CompanyLogo';
import SiteSidebar from './SiteSidebar';

export default {
    name: 'SiteHeader',

    components: { Logo, Dropdown, CompanyLogo, SiteSidebar },

    data: () => ({
        menuClosed: true,
    }),

    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('auth', ['isLoggedIn']),
    },

    methods: {
        toggleMenu() {
            this.menuClosed = !this.menuClosed;
        },

        handleLogout() {
            this.$store.dispatch('auth/logout', { redirect: true });
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';
$sidebar-width: 300px;

.SiteHeader {
    width: 100%;
    padding: $grid-gutter-width 0;
    background-color: $bg-color-1;

    .Container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include breakpoint(sm) {
            max-width: none;
        }
    }

    .main {
        display: flex;
        align-items: center;
    }

    .nav {
        margin-left: 30px;

        @include breakpoint(sm) {
            display: none;
        }

        a {
            position: relative;

            @include breakpoint(md) {
                padding-left: $grid-gutter-width;
                padding-right: $grid-gutter-width;
            }

            &.router-link-active:before {
                @include absolute-center(x);
                content: '';
                top: 100%;
                width: 50px;
                border-bottom: 1px solid $divider-color;
                margin-top: 5px;
            }
        }

        .navMenuItem {
            display: flex;
        }

    }

    .Logo {
        max-width: 190px;
        align-items: center;
    }

    .SiteSidebar {
        width: $sidebar-width;
        height: 100vh;
        position: fixed;
        top: 0;
        bottom: 0;
        transition: transform 250ms $ease-out;
        z-index: $z-index-modal;
        transform: translateX(-$sidebar-width);

        &.opened {
            transform: translateX(0);
        }
    }

    .sidebarOverlay {
        @include overlay(fixed);
        background-color: #000;
        z-index: $z-index-modal-bg;
        opacity: 0;
        visibility: hidden;
        transition:
            opacity 250ms $ease-out,
            display 0s linear 250ms;

        &.opened {
            opacity: 0.2;
            visibility: visible;
            transition: opacity 250ms $ease-out;
        }
    }

    .aside {
        @include breakpoint(sm) {
            display: none;
        }

        .Button + .Button {
            margin-left: 10px;
        }
    }

    .menu {
        width: 30px;
        height: 24px;
        position: relative;
        cursor: pointer;
        display: none;

        @include breakpoint(sm) {
            display: block;
        }

        span {
            display: block;
            position: absolute;
            height: 3px;
            width: 100%;
            background: $brand-primary;
            border-radius: 5px;
            opacity: 1;
            left: 0;
            transition: opacity 125ms $ease-out;
            opacity: 0.5;

            &:nth-child(1) { top: 0 }
            &:nth-child(2) { top: 10px }
            &:nth-child(3) { top: 20px }
        }

        &:hover span {
            opacity: 1;
        }
    }
}
</style>
